import { useNavigation } from '@zet/common/hooks/useNavigation'
import { Alert } from '@zet/design-system/alert'
import { Stack } from '@zet/design-system/layout'
import Pressable from '@zet/design-system/pressable'
import { B2, B5, H5 } from '@zet/design-system/typography'
import { i18n } from '@zet/localization'

export const BankPageErrorMessage = () => {
  const { navigate } = useNavigation()

  const onPress = () => {
    navigate('HelpAndSupport')
  }

  return (
    <Stack>
      <Stack className="mt-[28] w-72 items-center">
        <H5 family="graphie">{i18n.t('attemptsExpired')}</H5>
        <B2 className="text-grays-80 text-center">
          {i18n.t('bankStatusError')}
        </B2>
        <Pressable onPress={onPress}>
          <Alert intent="warning" className="mt-4">
            <B5 className="text-warning-200">
              {i18n.t('pleaseContact')}
              <B5 className="text-primary-100 font-[Graphie-Bold]">
                {i18n.t('customerSupport')}
              </B5>
              {i18n.t('forQueries')}
            </B5>
          </Alert>
        </Pressable>
      </Stack>
    </Stack>
  )
}
